import blackWhiteGeometric from "../assets/black_white_geometric.jpg";
import muslin from "../assets/muslin.jpg";
import whiteGreyStripe from "../assets/white_grey_stripe.jpg";
import tealShapes from "../assets/teal_shapes.jpg";
import grey from "../assets/grey.jpg";
import blackGreyChevron from "../assets/black_grey_chevron.jpg";
import navy from "../assets/navy.jpg";
import whiteTerrain from "../assets/terrain.jpg";
import watercolour from "../assets/watercolour.jpg";
import maskchains from "../assets/maskchains.jpeg";

export const MASKS = [
  {
    colour: "Mask Chains",
    swatchImg: maskchains,
    mailLink: "mailto:abbycmakes@gmail.com?subject=Mask Chains",
    displayButton: true
  },
  {
    colour: "Watercolour Horizon",
    swatchImg: watercolour,
    mailLink: "mailto:abbycmakes@gmail.com?subject=Watercolour Mask",
    displayButton: true
  },
  {
    colour: "Grey and White Terrain",
    swatchImg: whiteTerrain,
    mailLink: "mailto:abbycmakes@gmail.com?subject=Grey and White Terrain Mask",
    displayButton: true
  },
  {
    colour: "Muslin",
    swatchImg: muslin,
    mailLink: "mailto:abbycmakes@gmail.com?subject=Muslin Mask",
    displayButton: true
  },
  {
    colour: "White & Grey Stripes",
    swatchImg: whiteGreyStripe,
    mailLink: "mailto:abbycmakes@gmail.com?subject=White and Grey Stripes Mask",
    displayButton: true
  },
  {
    colour: "Teal Multicolour Shapes",
    swatchImg: tealShapes,
    mailLink:
      "mailto:abbycmakes@gmail.com?subject=Teal Multicolour Shapes Mask",
    displayButton: true
  },
  {
    colour: "Textured Grey",
    swatchImg: grey,
    mailLink: "mailto:abbycmakes@gmail.com?subject=Textured Grey Mask",
    displayButton: true
  },
  {
    colour: "Navy",
    swatchImg: navy,
    mailLink: "mailto:abbycmakes@gmail.com?subject=Navy Mask",
    displayButton: true
  },
  {
    colour: "Black & White Geometric Stripes",
    swatchImg: blackWhiteGeometric,
    // mailLink:
    //   "mailto:abbycmakes@gmail.com?subject=Black and White Geometric Stripes Mask",
    displayButton: false
  },
  {
    colour: "Black and Grey Chevron",
    swatchImg: blackGreyChevron,
    displayButton: false
    // mailLink: "
  }
];
